import React from 'react';
import { ThemeProvider, DefaultValidatorOptions } from 'react-admin-base-bootstrap';
const themes = {
    'light': {
        name: 'Light',
        // @ts-expect-error
        css: () => import('../../assets/app.lazy.css')
    },
    'dark': {
        name: 'Dark',
        // @ts-expect-error
        css: () => import('../../assets/app-dark.lazy.css')
    }
};
export default function Themes(props) {
    return React.createElement(DefaultValidatorOptions, null,
        React.createElement(ThemeProvider, { defaultTheme: "light", ...props, themes: themes }));
}
